import { makeAutoObservable } from 'mobx';

class SearchPropertyViewState {
  constructor() {
    makeAutoObservable(this);
  }

  state = null;

  open(property) {
    this.state = property;
  }

  close() {
    this.state = null;
  }

  init() {
    // this.recentPropertiesState = recentPropertiesState;
  }

  destroy() {
    this.close();
  }
}

export default SearchPropertyViewState;
